
module.exports= {
    styles: [
        {
            featureType: "poi",
            elementType: "labels",
            stylers: [
                { visibility: "off" }
            ]
        },
        {
            featureType: "transit.station",
            stylers: [
                { visibility: "off" }
            ]
        },
    {elementType: 'geometry', stylers: [{color: '#F0E3FF'}]},
{elementType: 'labels.text.fill', stylers: [{color: '#B089D3'}]},
{
    featureType: 'administrative.locality',
        elementType: 'labels.text.fill',
    stylers: [{color: '#B794E1'}]
},
{
    featureType: 'poi',
        elementType: 'labels.text.fill',
    stylers: [{color: '#B794E1'}]
},
{
    featureType: 'poi.park',
        elementType: 'geometry',
    stylers: [{color: '#E4C8FF'}]
},
{
    featureType: 'poi.park',
        elementType: 'labels.text.fill',
    stylers: [{color: '#81478C'}]
},
{
    featureType: 'road',
        elementType: 'geometry',
    stylers: [{color: '#F7E8FF'}]
},
{
    featureType: 'road',
        elementType: 'geometry.stroke',
    stylers: [{color: '#FA9BFA'}]
},
{
    featureType: 'road',
        elementType: 'labels.text.fill',
    stylers: [{color: '#9E69AF'}]
},
{
    featureType: 'road.highway',
        elementType: 'geometry',
    stylers: [{color: '#FFB8FF'}]
},
{
    featureType: 'road.highway',
        elementType: 'geometry.stroke',
    stylers: [{color: '#FA9BFA'}]
},
{
    featureType: 'road.highway',
        elementType: 'labels.text.fill',
    stylers: [{color: '#9E69AF'}]
},
{
    featureType: 'transit',
        elementType: 'geometry',
    stylers: [{color: '#FFFFFF'}]
},
{
    featureType: 'transit.station',
        elementType: 'labels.text.fill',
    stylers: [{color: '#9E69AF'}]
},
{
    featureType: 'water',
        elementType: 'geometry',
    stylers: [{color: '#D0B5FB'}]
},
{
    featureType: 'water',
        elementType: 'labels.text.fill',
    stylers: [{color: '#B097D7'}]
},
{
    featureType: 'water',
        elementType: 'labels.text.stroke',
    stylers: [{color: '#FA9BFA'}]
}
]
}


// WEBPACK FOOTER //
// ./src/Config/mapStyle.js